<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col cols="6">
                    <h1 class="headline font-weight-light mb-3">SAME ITEM</h1>
                </v-col>
                <v-col cols="6" class="text-right">
                    <v-btn
                        rounded
                        small
                        color="success"
                        class="mr-1"
                        @click="dialog_export_sameitem()"
                    >
                        Export claim ITEM
                    </v-btn>
                    <v-btn
                        rounded
                        small
                        color="primary"
                        @click="open_same_item()"
                        ><v-icon class="mr-1">mdi-plus</v-icon> Add claim
                        ITEM</v-btn
                    >
                </v-col>
            </v-row>
            <v-card class="mt-5">
                <v-row class="pa-5">
                    <v-col cols="11" sm="5" md="3"
                        ><v-autocomplete
                            class="mr-2"
                            :items="sameitem_status"
                            item-text="status_name"
                            item-value="status_id"
                            v-model="form_search.status"
                            menu-props="auto"
                            label="Select Status"
                            hide-details
                            @change="searchSame()"
                        ></v-autocomplete
                    ></v-col>
                    <v-col cols="11" sm="5" md="3"
                        ><v-text-field
                            v-model="form_search.serial"
                            append-icon="mdi-magnify"
                            label="Serial or Case ID"
                            @keyup="searchSame($event.target.value)"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="1" class="text-right mt-5">
                        <v-btn
                            x-small
                            fab
                            class="mr-1"
                            @click="reset()"
                            v-if="
                                form_search.status != '' ||
                                    form_search.serial != ''
                            "
                        >
                            <v-icon>mdi-rotate-left</v-icon></v-btn
                        ></v-col
                    >
                </v-row>
                <v-row class="mar-t-30">
                    <v-col cols="12">
                        <v-simple-table class="table-inv">
                            <template v-slot:default>
                                <thead>
                                    <tr class="col-tr-1">
                                        <th class="text-center">#</th>
                                        <th class="text-center">
                                            Project Name
                                        </th>
                                        <!-- <th class="text-center">Supplier</th> -->
                                        <th class="text-center">Case</th>
                                        <th class="text-center">Model</th>
                                        <th class="text-center">Serial</th>
                                        <th class="text-center">Symptoms</th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center">Print</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(row, index) in data_sameitem"
                                        :key="index"
                                    >
                                        <td class="text-center">
                                            {{ index + 1 }}.
                                        </td>
                                        <td>
                                            {{ row.project_name }}
                                        </td>
                                        <!-- <td>{{ row.supplier_name }}</td> -->
                                        <td class="text-center">
                                            <v-btn
                                                small
                                                color="white"
                                                rounded
                                                @click="view_log(row.log)"
                                            >
                                                <v-icon small color="primary"
                                                    >mdi-magnify</v-icon
                                                >
                                                <span
                                                    class="primary--text ml-1 mr-1"
                                                    >{{ row.case_id }}
                                                </span>
                                            </v-btn>
                                        </td>
                                        <td>
                                            {{ row.model }}
                                        </td>
                                        <td>{{ row.serial }}</td>
                                        <td>{{ row.symptom }}</td>
                                        <td>
                                            <v-btn
                                                v-if="row.next_status != null"
                                                :color="row.color"
                                                small
                                                class="mr-2"
                                                @click="
                                                    change_status(
                                                        row.next_status,
                                                        row.sameitem_id
                                                    )
                                                "
                                            >
                                                {{ row.status_name }}
                                            </v-btn>
                                            <v-btn
                                                v-if="row.next_status === null"
                                                small
                                                class="mr-2"
                                            >
                                                {{ row.status_name }}
                                            </v-btn>
                                        </td>
                                        <td>
                                            <router-link
                                                class="link-a"
                                                :to="
                                                    '/Inventory/Same-Item/' +
                                                        row.sameitem_id
                                                "
                                            >
                                                <v-btn fab small>
                                                    <v-icon small
                                                        >mdi-printer</v-icon
                                                    >
                                                </v-btn></router-link
                                            >
                                        </td>
                                    </tr>
                                    <br />
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <div>
                            <v-btn class="mx-2" fab small @click="back()">
                                <v-icon dark>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn
                                class="mx-2"
                                fab
                                small
                                :color="btn_color(n)"
                                v-for="n in page_count"
                                :key="n"
                                @click="get_claim_page(page_num_show(n))"
                            >
                                {{ page_num_show(n) }}
                            </v-btn>

                            <v-btn class="mx-2" fab small @click="next()">
                                <v-icon dark>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        
        
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <!-- <span class="headline">User Profile</span> -->
                        <!-- <v-spacer></v-spacer> -->
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model="form_search_caseId"
                                filled
                                rounded
                                dense
                                label="Search Case ID / Enter"
                                required
                                @keyup.enter="search_same_item()"
                            ></v-text-field>
                        </v-col>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row v-if="data_search.status == 'ok'">
                                <v-col cols="12" sm="6">
                                    <v-select
                                        :items="data_vendor"
                                        item-text="supplier_name"
                                        item-value="supplier_id"
                                        v-model="data_search.vendor"
                                        menu-props="auto"
                                        label="Select Vendor"
                                        hide-details
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        v-model="data_search.model"
                                        label="Model"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="data_search.serial"
                                        label="serial"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="data_search.symptom"
                                        label="symptom"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                     v-model="data_search.remark"
                                     label="Log Same Item"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row
                                v-if="data_search.status == 'error'"
                                class="mar-t-20"
                            >
                                <v-col cols="12">
                                    <span class="red--text">
                                        {{ data_search.remark }}
                                    </span>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close_same_item()"
                        >
                            Close
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="data_search.status == 'ok'"
                            small
                            color="success"
                            :disabled="data_search.vender == '' || data_search.remark == ''"
                            @click="save_same_item()"
                        >
                            <v-icon small class="mr-1">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog2" persistent max-width="400px">
                <v-card>
                    <v-card-title>
                        <span class="headline">REPAIR COMPLETE</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-dialog
                                        ref="dialog"
                                        v-model="modal"
                                        :return-value.sync="dates"
                                        persistent
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="dates"
                                                label="วันที่"
                                                prepend-icon=""
                                                readonly
                                                v-on="on"
                                                outlined
                                                dense
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="dates"
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="modal = false"
                                                >Cancel</v-btn
                                            >
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="
                                                    $refs.dialog.save(dates)
                                                "
                                                >OK</v-btn
                                            >
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close_status()"
                        >
                            Close
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="dates == ''"
                            small
                            color="success"
                            @click="save_status()"
                        >
                            <v-icon small class="mr-1">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog3" max-width="500px">
                <v-card>
                    <v-card-title>
                        <span class="headline">View Log</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container v-if="log.length > 0">
                            <v-row>
                                <v-col cols="12" v-for="(r, i) in log" :key="i">
                                    {{ i + 1 }}.
                                    <span class="mr-1 mr-1 primary--text">
                                        {{ (r.remark !== null ? r.remark : " ") }}
                                    </span>
                                    <span class="mr-1 mr-1 amber--text">
                                        {{ r.log_status }}
                                    </span>
                                    <span>
                                        {{
                                            "  " + r.log_name + " " + r.log_date 

                                        }}</span
                                    >
                                </v-col>
                            </v-row>
                        </v-container>
                    <span v-else>ไม่มีข้อมูล Log</span>
                    </v-card-text>
                    <v-card-actions>
                        <!-- <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog3 = false"
                        >
                            Close
                        </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_loading_export" persistent width="520">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Export Same item</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    dense
                                    outlined
                                    :items="data_projects"
                                    item-text="project_name"
                                    item-value="project_id"
                                    label="Projects"
                                    menu-props="auto"
                                    required
                                    hide-details
                                    v-model="select_pj"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="primary--text"
                        text
                        @click="dialog_export_sameitem_close()"
                    >
                        close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success darken-1"
                        rounded
                        :disabled="select_pj == ''"
                        @click="export_sameitem()"
                    >
                        Export Data
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
        this.get_data_status()
        this.get_projects()
    },
    created() {
        this.searchSame = _.debounce(this.searchSame, 300)
    },
    computed: {
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            let { data } = await axios.get(url + "same-item")
            // console.log(data, "data - same")
            this.data_main = data
            this.data_sameitem = data.data
            this.page_total = data.last_page
            this.page_total < 7
                ? (this.page_count = this.page_total)
                : (this.page_count = 7)
        },
        async get_projects() {
            this.dialog_loading = true
            await axios
                .get(url + "inventory/report", this.tk)
                .then((response) => {
                    this.data_projects = response.data.projects
                    this.dialog_loading = false
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        openDialogViewLog() {
       this.dialog_view_log = true; 
        },
        dialog_export_sameitem() {
            this.dialog_loading_export = true
        },
        dialog_export_sameitem_close() {
            this.select_pj = ""
            this.dialog_loading_export = false
        },
        async export_sameitem() {
            this.dialog_loading = true
            await axios({
                url: url + "same-item-export",
                method: "POST",
                responseType: "blob",
                data: { projects: this.select_pj },
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                // console.log(response)
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "report.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
                this.select_pj = ""
                this.dialog_loading_export = false
                this.dialog_loading = false
            })
        },
        async back() {
            let url = this.data_main.prev_page_url
            let { data } = await axios.get(url)
            this.data_sameitem = data.data
            this.data_main = data
        },
        async get_claim_page(num) {
            this.current_page = num
            if (num != "...") {
                let url_page = url + "same-item?page=" + num
                let { data } = await axios.get(url_page)
                this.data_sameitem = data.data
                this.data_main = data
            }
        },
        async next() {
            let urlxx = this.data_main.next_page_url

            let { data } = await axios.get(urlxx, {}, this.tk)
            this.data_sameitem = data.data
            this.data_main = data
        },

        btn_color(n) {
            if (this.page_count == 7) {
                if (this.data_main.current_page <= 4) {
                    return this.data_main.current_page === n ? "primary" : ""
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data_main.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data_main.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data_main.current_page - 1
                    chk4 = this.data_main.current_page
                    chk5 = this.data_main.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data_main.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        change_status(next_status, sameitem_id) {
            let part = {
                sameitem_id: sameitem_id,
            }
            if (next_status == "Repair complete") {
                this.sameitem_id = sameitem_id
                this.dialog2 = true
            } else {
                this.$swal({
                    title: "Change status to " + next_status + " ?",
                    text: "",
                    icon: "warning",
                    buttons: true,
                    primaryMode: true,
                }).then((confirm) => {
                    if (confirm) {
                        axios
                            .post(url + "same-item", part, {
                                headers: {
                                    Authorization:
                                        "Bearer " + localStorage.token,
                                },
                            })
                            .then((response) => {
                                this.get_data()
                                this.mutatesnackbar()
                                if (this.snackbar === true) {
                                    setTimeout(() => {
                                        this.mutatesnackbar()
                                    }, 3000)
                                }
                            })
                            .catch((error) => {
                                this.chk_data = true
                            })
                    }
                })
            }
        },
        async get_data_status() {
            let { data } = await axios.get(url + "status-same-item")
            this.sameitem_status = data
        },
        async searchSame() {
            this.dialog_loading = true
            // console.log(this.form_search)
            let { data } = await axios.get(
                url +
                    "same-item?status=" +
                    this.form_search.status +
                    "&serial=" +
                    this.form_search.serial
            )
            this.data_main = data
            this.data_sameitem = data.data
            this.page_total = data.last_page
            this.page_total < 7
                ? (this.page_count = this.page_total)
                : (this.page_count = 7)
            this.dialog_loading = false
        },
        reset() {
            this.form_search.status = ""
            this.form_search.serial = ""
            this.get_data()
        },
        open_same_item() {
            this.dialog = true
        },
        async search_same_item() {
            await axios
                .get(url + "search-same-item/" + this.form_search_caseId, this.tk)
                .then((response) => {
                    this.data_vendor = response.data.vendor
                    this.data_search = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        close_same_item() {
            this.data_search = []
            this.form_search = ""
            this.remark = ""
            this.dialog = false
        },
        async save_same_item() {
            // console.log(this.data_search, 'check save')
            await axios
                .post(url + "create-same-item", this.data_search, this.tk)
                .then((response) => {
                    this.mutatesnackbar()
                    this.close_same_item()
                    this.get_data()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
               
                .catch((error) => {
                    console.log(error)
                })
        },
        close_status() {
            this.sameitem_id = ""
            this.dates = ""
            this.dialog2 = false
        },
        async save_status() {
            let part = {
                sameitem_id: this.sameitem_id,
                date: this.dates,
            }
            await axios
                .post(url + "same-item", part, {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                })
                .then((response) => {
                    this.mutatesnackbar()
                    this.close_status()
                    this.get_data()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    this.chk_data = true
                })
        },
        view_log(logs) {
            this.log = logs
            this.dialog3 = true
        },
    },
    data() {
        return {
            dialog_loading: false,
            text: "Success, Your work has been saved",
            text_status: "",
            page_count: 0,
            data_main: [],
            data_sameitem: [],
            status_sameitem: "",
            sameitem_status: [],
            form_search_caseId: "",
            form_search: {
                status: "",
                serial: "",
            },
            dialog: false,
            data_search: [],
            data_vendor: [],
            tk: null,
            dialog2: false,
            sameitem_id: "",
            dates: "",
            modal: false,
            log: [],
            dialog3: false,
            data_projects: [],
            select_pj: "",
            dialog_loading_export: false,
        }
    },
}
</script>
